import { Crown, CheckCircle2 } from "lucide-react";

export const MgrStageBadge = ({ r, testid }) => {
  if (r?.mgr_stage === "pending") return (
    <span data-testid={testid} className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-semibold text-amber-700">
      <Crown className="h-3 w-3" /> بانتظار مدير القسم{r.mgr_name ? `: ${r.mgr_name}` : ""}
    </span>
  );
  if (r?.mgr_stage === "approved") return (
    <span data-testid={testid} className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700">
      <CheckCircle2 className="h-3 w-3" /> وافق مدير القسم{r.mgr_decided_by ? `: ${r.mgr_decided_by}` : ""}
    </span>
  );
  if (r?.mgr_stage === "rejected") return (
    <span data-testid={testid} className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2 py-0.5 text-[10px] font-semibold text-rose-700">
      <Crown className="h-3 w-3" /> رفضه مدير القسم{r.mgr_decided_by ? `: ${r.mgr_decided_by}` : ""}
    </span>
  );
  return null;
};
